import React from 'react';
import { useSelector } from 'react-redux';

import { KompisLanguageSelector } from '@inter-ikea-kompis/react-components';
import { changeLocale } from '../../util/locale';

import constants from '../../settings/constants';
import storage from '../../services/history/storage';
import { SkapaTheme } from '@inter-ikea-kompis/themes';
import { applicationSettings } from '../../settings/application';
import classNames from 'classnames';
import styles from './TopBar.module.less';
import { selectKompisTranslations } from '../../state/translations/translationsSelectors';
import { selectDexfSettings } from '../../state/dexfSettings/dexfSettingsSelectors';
import { selectCurrentView } from '../../state/navigation/navigationSelectors';
import { selectLocale } from '../../state/summary/summarySelectors';
import localStatisticsReporter from '../../services/statistics/insights/custom/local/localStatisticsReporter';
import { selectScreensaverIsActive } from '../../state/screensaver/screensaverSelectors';
import { useKioskIntegration } from '../../hooks/useKioskIntegration';

const LanguageSelector: React.FC = () => {
  const currentView = useSelector(selectCurrentView);
  const kompisTranslations = useSelector(selectKompisTranslations);
  const dexfSettings = useSelector(selectDexfSettings);
  const screenSaverActive = useSelector(selectScreensaverIsActive);
  const locale = useSelector(selectLocale);

  const { integration, isGallery } = useKioskIntegration();

  const [visibleModal, setVisibleModal] = React.useState();

  React.useEffect(() => {
    storage.session.removeItem(
      constants.SESSION_STORAGE.LANGUAGE_PICKER_ACTIVE_VIEW_KEY
    );
  }, []);

  React.useEffect(() => {
    onModalClose();
  }, [screenSaverActive]);

  const onModalOpen = ({ detail: { visibleModal } }: any) =>
    setVisibleModal(visibleModal);

  const onModalClose = () => setVisibleModal(undefined);

  const onChange = ({ detail: { locale } }: any) => {
    storage.session.setItem(
      constants.SESSION_STORAGE.LANGUAGE_PICKER_ACTIVE_VIEW_KEY,
      currentView
    );
    const fromLocale = applicationSettings.locale.slice();

    isGallery && integration?.languageChange(locale);

    changeLocale(window.location.href, fromLocale, locale);
    localStatisticsReporter.reportLanguageSelectorUserChoice(
      fromLocale,
      locale,
      currentView
    );
  };

  return (
    <KompisLanguageSelector
      locale={locale}
      className={classNames(styles.LanguageSelector)}
      visibleModal={visibleModal}
      onChange={onChange}
      onModalOpen={onModalOpen}
      onModalClose={onModalClose}
      translations={kompisTranslations}
      settings={dexfSettings}
      theme={SkapaTheme}
    />
  );
};

export default LanguageSelector;
